// removed by extract-text-webpack-plugin
module.exports = {"footer":"_3zYqFRVOXAKJzLEEtgQrhi","frame":"S1IbhF6NcbFXY4Q2PwQBE"};


//////////////////
// WEBPACK FOOTER
// ./src/css/components/footer.css
// module id = 342
// module chunks = 0